module.exports = __webpack_public_path__ + "img/img_detail3_mobile.94e8eaac.png";